// Network Configurations for opBNB
// Change ACTIVE_NETWORK to switch between testnet and mainnet

export const NETWORKS = {
  OPBNB_MAINNET: {
    chainId: '0xCC',
    chainIdDecimal: 204,
    chainName: 'opBNB Mainnet',
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18
    },
    rpcUrls: ['https://opbnb-mainnet-rpc.bnbchain.org'],
    blockExplorerUrls: ['https://opbnbscan.com']
  },
  OPBNB_TESTNET: {
    chainId: '0x15EB',
    chainIdDecimal: 5611,
    chainName: 'opBNB Testnet',
    nativeCurrency: {
      name: 'tBNB',
      symbol: 'tBNB',
      decimals: 18
    },
    rpcUrls: ['https://opbnb-testnet-rpc.bnbchain.org'],
    blockExplorerUrls: ['https://testnet.opbnbscan.com']
  }
};

// ============================================
// CHANGE THIS TO SWITCH NETWORK
// ============================================
export const ACTIVE_NETWORK = 'OPBNB_MAINNET';

export const getActiveNetwork = () => NETWORKS[ACTIVE_NETWORK];
export const getChainId = () => NETWORKS[ACTIVE_NETWORK].chainIdDecimal;
export const getChainIdHex = () => NETWORKS[ACTIVE_NETWORK].chainId;
